import React from 'react';
import PropTypes from 'prop-types';
import BaseCard from '../BaseCard';
import ElidedText from '../ElidedText';
import {LANDSCAPE__24} from '@homeaway/svg-defs/lib/defs/LANDSCAPE__24';
import withLink from '../withLink';
import Affinities from '../Affinities';
import ListingsCount from '../ListingsCount';

const DestinationCard = ({affinities, listingsCount, subtitle, ...rest}) => {
    const children = [];

    if (subtitle) {
        children.push(<ElidedText key="subtitle">{subtitle}</ElidedText>);
    }

    if (listingsCount) {
        children.push(
            <ListingsCount key="listingsCount">{listingsCount}</ListingsCount>
        );
    }

    if (affinities) {
        children.push(<Affinities key="affinities" {...affinities} />);
    }

    return (
        <BaseCard {...rest}>{children.length > 0 ? children : null}</BaseCard>
    );
};

DestinationCard.propTypes = {
    ...BaseCard.propTypes,
    /** Affinities */
    affinities: PropTypes.shape({...Affinities.propTypes}),
    /** Listings count formatted string */
    listingsCount: PropTypes.string,
    /** The card subtitle */
    subtitle: PropTypes.string,
    svgIcon: PropTypes.string,
};

DestinationCard.defaultProps = {
    ...BaseCard.defaultProps,
    svgIcon: LANDSCAPE__24,
};

export default withLink(DestinationCard);
